import { Colors } from '@kvika/audur-theme'

import { GridItem, MainGridContainer } from '../grid-container'
import LinkCard from '../linkCard/LinkCard'
import ImageCard from '../imageCard/ImageCard'
import { Route } from '../../utils/navigation/Routes'
import { TranslatedStrings } from '../../utils/translations/TranslatedStrings'
import { ColumnClass, Gutters } from '../../utils/types/Types'

const ErrorBoundaryFallback = (): JSX.Element => {
	const { Page500 } = TranslatedStrings.is
	return (
		<MainGridContainer backgroundColor={Colors.DarkGray} gutters={Gutters.Both} style={{ minHeight: 600 }}>
			<GridItem className={ColumnClass.Left}>
				<LinkCard
					heading={<h1>{Page500.heading}</h1>}
					subHeading={<h3>{Page500.subHeading}</h3>}
					linkSource={{
						href: Route.Home,
						title: Page500.linkText,
					}}
				/>
			</GridItem>
			<GridItem className={ColumnClass.Right}>
				<ImageCard
					imageSource={{
						src: '/svg/people_rowing.svg',
						alt: 'people_rowing',
						width: 500,
						height: 500,
					}}
				/>
			</GridItem>
		</MainGridContainer>
	)
}

export default ErrorBoundaryFallback
